import { Box } from '@mui/material'
import { ReactElement } from 'react'
import { GroupCowStatus } from '../models/IGroup'
import { TypographyPrimary } from './typography/TypographyPrimary'

interface IInfoChipItemProps {
	bgColor: string
	statusKey?: keyof typeof GroupCowStatus
	label?: string
	labelColor: string
	icon?: ReactElement
}

const InfoChipItem = (props: IInfoChipItemProps) => {
	const { bgColor, statusKey, label, labelColor, icon } = props
	return (
		<Box
			sx={{
				width: 'max-content',
				borderRadius: '12px',
				height: 'auto',
				backgroundColor: bgColor,
				padding: '4px 8px',
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				gap: '4px',
			}}
		>
			{icon && icon}
			<TypographyPrimary
				sx={{
					textAlign: 'center',
					color: labelColor,
				}}
			>
				{label ?? (statusKey ? GroupCowStatus[statusKey] : '')}
			</TypographyPrimary>
		</Box>
	)
}

export default InfoChipItem
